import { Router } from './projects/portfolio/flaxCode';

export const Src = () => <Router />;
